export default "__VITE_ASSET__DkbtBNck__"